import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

export const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav className="w-full bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <div className="h-14 flex items-center justify-between">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <img src="/logo512.png" alt="Logo" className="h-8 w-8 sm:h-10 sm:w-10" />
            <span className="hidden xs:inline text-base sm:text-lg font-semibold text-gray-900">{t('navbar.dashboard')}</span>
          </div>
          <div className="flex items-center space-x-2 sm:space-x-4">
            <span className="hidden md:block text-sm text-gray-700 max-w-[150px] lg:max-w-none truncate" title={user?.email}>{user?.email || ''}</span>
            <button
              onClick={logout}
              className="inline-flex items-center justify-center py-1.5 px-2 sm:px-3 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              title={t('navbar.logout')}
            >
              <svg className="w-5 h-5 sm:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span className="hidden sm:inline">{t('navbar.logout')}</span>
            </button>
            <button
              onClick={toggleLanguage}
              className="inline-flex items-center justify-center py-1.5 px-2 sm:px-3 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              title="Change language"
            >
              <svg className="w-5 h-5 sm:mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
              </svg>
              <span className="hidden sm:inline">{i18n.language === 'en' ? 'FR' : 'EN'}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}; 